export const stations = {
    start: {
        number: "🎂",
        title: "Happy Birthday Sivani!",
        subtitle: "Eine Reise durch unsere schönsten Erinnerungen - zu deinem 26. Geburtstag 2025",
        isStart: true
    },
    pingpong: {
        number: "1",
        title: "🏓Ping Pong🏓",
        memory: "Lieb üsi Ping Pong Partie, wo du mich immer wieder mal besiegt hasch!💀, aber ihrgend wie hats trotztdem Spass gmacht. Isch glaub langsam ziit zum Dich als Ping Pong Queen zkröne! 👑",
        photos: [
            {
                src: "/images/pingpong/pingpong1.jpeg",
                protected: false
            },
            {
                src: "/images/pingpong/pingpong3.jpeg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/pingpong/pingpong1.MP4",
                protected: false
            },
            {
                type: "video",
                src: "/videos/pingpong/looser.MOV",
                protected: false
            },
            {
                src: "/images/pingpong/pingpong4.jpg",
                protected: false
            }
        ],
        hint: "Gömmer mal zu üse lieblings Parkplatz/Spot. Döt wartet e wiiteri Erinnerung uf dich! 🚗",
        nextStation: "parkplatz",
        prevStation: "start"
    },
    parkplatz: {
        number: "2",
        title: "Lieblings Parkplatz",
        memory: "Ah dem ort händ mir scho so viel erlebt gueti und schlechti ziite.Wir hand zäme gschwätzt, gelacht und eifach d'Ziit gnosse. D'Erinnerige an die Momänt sind unvergesslich! ❤️",
        photos: [
            {
                src: "/images/auto/1.jpg",
                protected: false
            },
            {
                src: "/images/auto/2.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/auto/2.MOV",
                protected: false
            },
            {
                src: "/images/auto/3.jpg",
                protected: true
            },
            {
                type: "video",
                src: "/videos/auto/3.MP4",
                protected: true
            },
            {
                src: "/images/auto/4.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/auto/5.MP4",
                protected: true
            },
            {
                src: "/images/auto/14.jpg",
                protected: false
            },
            {
                src: "/images/auto/5.jpg",
                protected: false
            },
            {
                src: "/images/auto/6.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/auto/6.MOV",
                protected: false
            },
            {
                src: "/images/auto/7.jpg",
                protected: false
            },
            {
                src: "/images/auto/8.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/auto/8.mov",
                protected: false
            },
            {
                src: "/images/auto/9.jpg",
                protected: false
            },
            {
                src: "/images/auto/10.jpg",
                protected: false
            },
            {
                src: "/images/auto/11.jpg",
                protected: false
            },
            {
                src: "/images/auto/12.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/auto/12.MP4",
                protected: false
            },
            {
                src: "/images/auto/0.jpg",
                protected: false
            },
            {
                src: "/images/auto/13.jpg",
                protected: false
            },
            {
                src: "/images/auto/15.jpg",
                protected: false
            },
            {
                src: "/images/auto/16.jpg",
                protected: false
            }
        ],
        hint: "Ez deffsch mal go en chillige iced cafe latte mit caramel sirup go bstelle und trinke. ☕️, dort wartet die nächsti Surprise uf dich! 🏪",
        nextStation: "starbucks",
        prevStation: "pingpong"
    },
    starbucks: {
        number: "3",
        title: "Starbucks",
        memory: "So gnüss dini Kaffi und Gschenkli 😊. Hoffe es gfallt dir! denkt ich hau mal paar erinnerigs Fotis ine.",
        photos: [
            {
                src: "/images/geschenk/1.jpg",
                protected: false
            },
            {
                src: "/images/geschenk/2.jpg",
                protected: false
            },
            {
                src: "/images/geschenk/3.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/geschenk/3.MOV",
                protected: false
            },
            {
                src: "/images/geschenk/4.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/geschenk/5.MP4",
                protected: false
            },
            {
                src: "/images/geschenk/5.jpg",
                protected: false
            }
        ],
        hint: "So gömmer go lerne, weisch no det woni uf dich am morge gwartet han zum dich gseh. Döt wartet die nächsti Erinnerig",
        nextStation: "ost",
        prevStation: "parkplatz"
    },
    ost: {
        number: "4",
        title: "Good old Times",
        memory: "Ich nimm dich mal mit uf en Rückblick i d'Ziit, chlini erinnerige an die guete alte Ziit. Ich hoffe du gniessisch es so wie ich. 🥰",
        photos: [
            {
                src: "/images/erinnerungen/1.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/2.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/3.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/4.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/5.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/6.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/7.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/8.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/9.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/10.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/11.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/12.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/13.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/erinnerungen/13.MP4",
                protected: false
            },
            {
                type: "video",
                src: "/videos/erinnerungen/13.MOV",
                protected: true
            },
            {
                src: "/images/erinnerungen/14.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/erinnerungen/14.MP4",
                protected: false
            },
            {
                type: "video",
                src: "/videos/erinnerungen/144.MP4",
                protected: false
            },
            {
                src: "/images/erinnerungen/15.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/erinnerungen/15.MP4",
                protected: true
            },
            {
                src: "/images/erinnerungen/16.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/erinnerungen/16.MP4",
                protected: true
            },
            {
                src: "/images/erinnerungen/17.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/18.jpg",
                protected: true
            },
            {
                src: "/images/erinnerungen/19.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/20.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/erinnerungen/20.MP4",
                protected: false
            },
            {
                src: "/images/erinnerungen/21.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/22.jpg",
                protected: false
            },
            {
                src: "/images/erinnerungen/23.jpg",
                protected: false
            }
        ],
        hint: "Ah dem Ort simmer oft here gfahre zum eh schöni ussicht uf züriseegnüsse und 2sammkeits gnüsse.",
        nextStation: "versteck",
        prevStation: "starbucks"
    },
    versteck: {
        number: "5",
        title: "Lets Get Crazy",
        memory: "Ah dem Ort hani viel Crazy Erinnerige mit dir. Drum nimm ich dich uf eh reis wo mer ganz crazy gsie sind 🤪",
        photos: [
            {
                type: "video",
                src: "/videos/crazy/1.mp4",
                protected: true
            },
            {
                type: "video",
                src: "/videos/crazy/2.MOV",
                protected: true
            },
            {
                type: "video",
                src: "/videos/crazy/3.mp4",
                protected: true
            },
            {
                src: "/images/crazy/03.jpg",
                protected: true
            },
            {
                src: "/images/crazy/3.jpg",
                protected: true
            },
            {
                src: "/images/crazy/4.jpg",
                protected: true
            },
            {
                type: "video",
                src: "/videos/crazy/5.MP4",
                protected: true
            },
            {
                type: "video",
                src: "/videos/crazy/05.MOV",
                protected: false
            },
            {
                type: "video",
                src: "/videos/crazy/6.MP4",
                protected: false
            },
            {
                type: "video",
                src: "/videos/crazy/05.MP4",
                protected: true
            },
            {
                src: "/images/crazy/8.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/crazy/7.MOV",
                protected: false
            },
            {
                type: "video",
                src: "/videos/crazy/8.MP4",
                protected: true
            },
            {
                type: "video",
                src: "/videos/crazy/12.MP4",
                protected: false
            },
            {
                src: "/images/crazy/10.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/crazy/9.MOV",
                protected: false
            },
            {
                type: "video",
                src: "/videos/crazy/10.MOV",
                protected: false
            },
            {
                type: "video",
                src: "/videos/crazy/11.MP4",
                protected: true
            }
        ],
        hint: "Und jetzt gommer zäme go schaukle und es spazierli am see go mache, wie frühener. Döt wartet die nächschti Station uf dich!",
        nextStation: "schaukel",
        prevStation: "zusammen"
    },
        schaukel: {
        number: "6",
        title: "Schaukel",
        memory: "Wir sind so oft scho zämme da duregloffe, und sogar mal da am schaukle gsie. Ich wot das mer egal wie alt mir sind, immer wieder mal uf eh schaukel sitzet und d'Ziit zäme gnüsse. 🛝",
        photos: [
            {
                type: "video",
                src: "/videos/schaukel/1.MP4",
                protected: false
            },
            {
                src: "/images/schaukel/2.jpg",
                protected: false
            },
            {
                src: "/images/schaukel/3.jpg",
                protected: false
            },

            {
                src: "/images/schaukel/4.jpg",
                protected: false
            },
            {
                src: "/images/schaukel/04.jpg",
                protected: false
            },

            {
                src: "/images/schaukel/05.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/schaukel/4.mp4",
                protected: false
            },
            {
                src: "/images/schaukel/5.jpg",
                protected: false
            },
            {
                src: "/images/schaukel/7.jpg",
                protected: false
            },
            {
                src: "/images/schaukel/07.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/schaukel/10.MP4",
                protected: false
            },
            {
                src: "/images/schaukel/8.jpg",
                protected: false
            },
            {
                src: "/images/schaukel/9.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/schaukel/9.MP4",
                protected: false
            },
            {
                src: "/images/schaukel/10.jpg",
                protected: false
            },
            {
                src: "/images/schaukel/11.jpg",
                protected: false
            },
            {
                src: "/images/schaukel/12.jpg",
                protected: true
            },
            {
                type: "video",
                src: "/videos/schaukel/6.MP4",
                protected: false
            }
        ],
        hint: "❤️09.März.2023 , hehe❤️",
        nextStation: "zusammen",
        prevStation: "versteck"
    },

    zusammen: {
        number: "7",
        title: "❤️ 09-März-2023 ❤️",
        memory: "Ich wot üsi schöni ziite zämme festhalte, drum han ich paar Fotis und Videos für dich zäme gstellt🥰. Und es bsunders Gschenkli wartet au uf dich - will wänn du das nächschte mal Geburtstag fiihrsch, sind mir scho als glücklichs Ehepaar verbunde 💍❤️",
        photos: [
            {
                src: "/images/love/001.jpg",
                protected: false
            },
            {
                src: "/images/love/002.jpg",
                protected: false
            },
            {
                src: "/images/love/003.jpg",
                protected: false
            },
            {
                src: "/images/love/004.jpg",
                protected: true
            },
            {
                src: "/images/love/1.jpg",
                protected: true
            },
            {
                src: "/images/love/01.jpg",
                protected: true
            },
            {
                src: "/images/love/2.jpg",
                protected: true
            },
            {
                src: "/images/love/02.jpg",
                protected: true
            },
            {
                src: "/images/love/006.jpg",
                protected: true
            },
            {
                type: "video",
                src: "/videos/love/2.MOV",
                protected: true
            },
            {
                src: "/images/love/3.jpg",
                protected: false
            },
            {
                src: "/images/love/4.jpg",
                protected: false
            },
            {
                src: "/images/love/005.jpg",
                protected: true
            },
            {
                src: "/images/love/5.jpg",
                protected: false
            },
            {
                src: "/images/love/05.jpg",
                protected: true
            },
            {
                src: "/images/love/6.jpg",
                protected: true
            },
            {
                type: "video",
                src: "/videos/love/6.MP4",
                protected: false
            },
            {
                src: "/images/love/06.jpg",
                protected: false
            },
            {
                src: "/images/love/7.jpg",
                protected: true
            },
            {
                src: "/images/love/8.jpg",
                protected: false
            },
            {
                type: "video",
                src: "/videos/love/8.MOV",
                protected: false
            },
            {
                src: "/images/love/9.jpg",
                protected: false
            },
            {
                src: "/images/love/10.jpg",
                protected: false
            }
        ],
        hint: "",
        nextStation: "essen",
        prevStation: "schaukel"
    },
    essen: {
        number: "🎉",
        title: "Finale - Essen",
        memory: "Daymm , Sivania Kokka.\n Du hasch die Schnizeljagt so locker gschafft! Jetzt isch es ziit für es feins Znacht zäme. Ich hoffe du hesch Spass gha und hasch es gnosse. \nVergiss nöd, du bisch und wirsch min chline Pingu sie für immer 🐧💕",
        photos: [
            {
                src: "/images/schaukel/13.jpg",
                protected: false
            }
        ],
        isFinal: true,
        prevStation: "schaukel"
    }
};